module.exports = __webpack_public_path__ + "img/am-logo.e5840405.png";